"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const icon_new_1 = __importDefault(require("../icon-new"));
const divider_1 = __importDefault(require("../divider"));
const { ChevronDown } = icon_new_1.default;
const ItemHeader = styled_components_1.default.div `
  display: grid;
  grid-template-columns: auto 24px;
  grid-gap: 16px;
  align-items: center;
  padding: 24px 16px 8px;
  cursor: ${({ isDisabled }) => (isDisabled ? "default" : "pointer")};
`;
const Label = styled_components_1.default.div `
  font-weight: 500;
  font-size: 20px;
`;
const ChevronIcon = (0, styled_components_1.default)(ChevronDown) `
  transition: 150ms;
  transform: translateY(2px)
    ${({ $isOpened }) => ($isOpened ? "scale(-1)" : "")};
`;
const ContentWrapper = styled_components_1.default.div `
  transition: 200ms;
  overflow: hidden;
  max-height: ${({ $isOpened, $maxHeight }) => $isOpened ? `${$maxHeight}px` : "0px"};
`;
const RotaAccordionItem = (_a) => {
    var _b;
    var { isOpened, children, isDisabled = false, label, toggleItem } = _a, props = __rest(_a, ["isOpened", "children", "isDisabled", "label", "toggleItem"]);
    const ref = (0, react_1.useRef)(null);
    return (react_1.default.createElement("li", Object.assign({}, props),
        react_1.default.createElement(ItemHeader, { onClick: () => {
                if (!isDisabled && toggleItem)
                    toggleItem();
            }, isDisabled: isDisabled },
            react_1.default.createElement(Label, null, label),
            react_1.default.createElement(ChevronIcon, { "$isOpened": isOpened })),
        react_1.default.createElement(divider_1.default, { margin: 8 }),
        react_1.default.createElement(ContentWrapper, { "$isOpened": isOpened, "$maxHeight": (_b = ref === null || ref === void 0 ? void 0 : ref.current) === null || _b === void 0 ? void 0 : _b.clientHeight },
            react_1.default.createElement("div", { ref: ref }, children))));
};
exports.default = RotaAccordionItem;
